module.exports = __webpack_public_path__ + "img/user.f9f26790.png";